import { BounceZoomIn, BounceZoomOut, SwipeFromBottomOut, ZoomOut } from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contract";
import * as TweenJS from "slotworks/utils/tween";
import settingsModel from "slotworks/model/settings/settings-model";
import gameState from "slotworks/model/game-state";
import soundManager from "slotworks/sound/sound-manager";

export default class HarleyTotalWinTransitions extends AbstractSceneTransition {

    private BOUNCE_TIME: number = 400;

    private noWinWin: boolean;

    public in(): Contract<void> {
        return new Contract((resolve) => {
            Layers.CelebrationContent.getSprite("reelfilter").visible = false;
            this.noWinWin = settingsModel.isUKJurisdiction() && !gameState.getCurrentGame().isWinAboveBet();
            if(this.noWinWin) {
                this.formatLowWinText();
                Layers.CelebrationContent.getSprite("filter").visible = false;                
                Layers.CelebrationContent.getSprite("reelfilter").visible = false;
                resolve(null);
            } else {
                BounceZoomIn(Layers.CelebrationContent.getSprite("filter"), this.BOUNCE_TIME, 0).execute();
                BounceZoomIn(Layers.CelebrationContent.getSprite("value"), this.BOUNCE_TIME, 0).then(resolve);
            }
        });
    }

    public out(): Contract<void> {
        return new Contract((resolve) => {
            if(this.noWinWin)
                resolve(null);
            else {
                soundManager.customEvent("tally_collect");
                BounceZoomOut(Layers.CelebrationContent.getSprite("filter"), this.BOUNCE_TIME, 0).execute();
                BounceZoomOut(Layers.CelebrationContent.getSprite("value"), this.BOUNCE_TIME, 0).then(resolve);
            }
        });
    }

    public destroy() {
        const value = Layers.CelebrationContent.getSprite("value");
        if(value) {
            TweenJS.removeAll(value);
            TweenJS.removeAll(value.scale);
        }
        const filter = Layers.CelebrationContent.getSprite("filter");
        if(filter) {
            TweenJS.removeAll(filter);
            TweenJS.removeAll(filter.scale);
        }
        super.destroy();
    }

    private formatLowWinText() {
        const text = Layers.CelebrationContent.getSprite("value");
        const scale = text.scale.x * 0.7;
        text.scale.set(scale, scale);
        text.tint = 0xcccccc;
    }

}
